import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';

const baseURL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';
export const apiClient = axios.create({ baseURL });

apiClient.interceptors.request.use(async (config) => {
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.location.assign('/login');
    }
    return Promise.reject(error);
  }
);
